<script setup lang="ts">
import type { Schemas } from '#shopware'
import { pascalCase } from 'scule'

useRouteCache((helper) => {
    helper.setMaxAge(60).setCacheable()
})

const { resolvePath } = useNavigationSearch()
const { fetchPopups } = usePagePopups()
const route = useRoute()
const { locale } = useI18n()
const routePath = route.path.replace(new RegExp('\\b'+`${locale.value}`+'\\b'), '').replace('//', '/')
const { getPageComponent } = useFrontendPageRegistry()

const { data } = await useAsyncData(
    `cmsResponse${routePath}`,
    () => {
        return Promise.all([resolvePath(routePath), fetchPopups(routePath)]);
    },
)

const seoResult = computed(() => data.value?.[0])
const popups = computed(() => data.value?.[1] ?? [])

if (!seoResult.value?.foreignKey) {
    console.error('index.vue:', `No data found in API for ${routePath}`)

    throw createError({
        statusCode: 404,
        statusMessage: `No data fetched from API for ${routePath}`,
    })
}

const { routeName, foreignKey } = useNavigationContext(
    seoResult as Ref<Schemas['SeoUrl']>,
)

const pageComponent = computed(() => {
    const componentName = pascalCase(routeName.value as string)
    return getPageComponent(componentName)
})

const currentPageType = computed(() => {
    if (routeName.value === 'frontend.navigation.page') return 'category'
    if (routeName.value === 'frontend.detail.page') return 'detail'
    if (routeName.value === 'frontend.landing.page') return 'cms'
    return undefined
})

// Set canonical URL for SEO
const { setCanonicalUrl } = useCanonicalUrl()
setCanonicalUrl()

useHead({
    link: computed(() =>
        (seoResult.value?.extensions?.hreflang ?? []).map((lang, index) => ({
            key: `hreflang-${index}`,
            rel: 'alternate',
            hreflang: lang.locale,
            href: lang.url,
        }))
    ),
})
</script>

<template>
    <main>
        <component :is="pageComponent" v-if="pageComponent" :navigation-id="foreignKey" />
        <NewsletterConfirmationModal />
        <PopupRenderer :popups="popups" :current-page-type="currentPageType" />
    </main>
</template>